import { EthereumProvider } from "@walletconnect/ethereum-provider"
const CONFIG_RPC = {
	39: "https://rpc-testnet.uniultra.xyz/",
	56: 'https://bsc-dataseed.binance.org/',
	1: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
  296: 'https://testnet.hashio.io/api',
  2484: 'https://rpc-nebulas-testnet.uniultra.xyz/',
}
export const wc_connect = async (chainId) => {
  try {
    const _chain = chainId || 39 //this.chainId === 'u2u' ? 39 : 296
    const provider = await EthereumProvider.init({
        projectId: 'e68fa97d2ee35d5db31327735b031471',
        chains: [_chain],
        optionalChains: ['39', '296', '2484'],
        rpcMap: {
          39: CONFIG_RPC[39],
          296: CONFIG_RPC[296],
          2484: CONFIG_RPC[2484]
        },
      showQrModal: true,
      });
      provider.modal.subscribeModal((newState) => {
        if(!newState?.open) {
          try {
            document.getElementsByTagName("wcm-modal")[0]?.remove()
          }catch(ex){
            console.error(ex)
          }
        }
      })
    return provider
  }catch(ex){
  console.error(ex)
  }
}